import { useContext } from "react";
import { PrimaryButton } from "../button";
import { ACTION_BUTTON } from "./plenary-download";
import { StepActions } from "./step-actions";
import { StepperContext } from "./stepper";

interface DownloadCropSelectProps {
  selectCrop: (crop: boolean) => void;
}

export function DownloadCropSelect({ selectCrop }: DownloadCropSelectProps) {
  const { step, steps, cancel } = useContext(StepperContext);

  const active = step === steps - 1;

  return (
    <div>
      <span className="block mb-4 font-semibold">Möchten Sie das Video individuell zuschneiden?</span>
      <div className="flex items-stretch gap-4">
        <PrimaryButton className={ACTION_BUTTON} disabled={!active} onClick={() => selectCrop(false)}>
          Download ohne Zuschnitt starten
        </PrimaryButton>
        <PrimaryButton
          className={ACTION_BUTTON}
          style={{ height: "unset" }}
          disabled={!active}
          onClick={() => selectCrop(true)}
        >
          Zuschneiden
        </PrimaryButton>
      </div>
      <StepActions cancelLabel="Abbrechen" cancelDisabled={!active} handleCancel={cancel} />
    </div>
  );
}
